import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=6a130a4f"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports